// Monta o envio do link do contrato por um modelo aprovado do WhatsApp (necessário fora da
// janela de 24 h). O link precisa ir na mensagem: numa variável do texto ou no final de um
// botão de URL dinâmica (ex.: https://link.talkvia.com.br/{{1}}).

const VARIABLE_PATTERN = /\{\{\s*([\w.]+)\s*\}\}/g;
const GREETING_PATTERN = /(ol[áa]|oi|prezad[oa]|caro|cara)[\s,!]*$/i;

const componentsOf = template =>
  Array.isArray(template?.components) ? template.components : [];

const findComponent = (template, type) =>
  componentsOf(template).find(component => component.type === type);

const variablesIn = text =>
  [...String(text || '').matchAll(VARIABLE_PATTERN)].map(match => ({
    key: match[1],
    before: String(text).slice(0, match.index),
  }));

export const firstName = name =>
  String(name || '')
    .trim()
    .split(/\s+/)[0] || '';

// Botão de URL com variável cujo endereço fixo é o começo do link do contrato.
export const dynamicUrlButton = (template, publicUrl) => {
  const buttons = findComponent(template, 'BUTTONS')?.buttons || [];
  const index = buttons.findIndex(
    button => button.type === 'URL' && /\{\{\s*1\s*\}\}/.test(button.url || '')
  );
  if (index === -1) return null;

  const base = buttons[index].url.split('{{')[0];
  const link = String(publicUrl || '');
  const matches = Boolean(base) && link.startsWith(base);
  return {
    index,
    base,
    matches,
    suffix: matches ? link.slice(base.length) : '',
  };
};

// Campos editáveis do modelo, já com sugestão: saudação recebe o primeiro nome; sem botão
// dinâmico, a primeira variável restante recebe o link.
export const templateFields = (template, { recipientName, publicUrl }) => {
  const button = dynamicUrlButton(template, publicUrl);
  let linkAssigned = Boolean(button?.matches);
  const name = firstName(recipientName);

  const build = (component, text) =>
    variablesIn(text).map(({ key, before }) => {
      let value = '';
      if (GREETING_PATTERN.test(before)) value = name;
      else if (!linkAssigned && component === 'body') {
        value = publicUrl;
        linkAssigned = true;
      }
      return { component, key, value };
    });

  const header = findComponent(template, 'HEADER');
  return [
    ...(header?.format === 'TEXT' ? build('header', header.text) : []),
    ...build('body', findComponent(template, 'BODY')?.text),
  ];
};

export const carriesLink = (template, fields, publicUrl) =>
  Boolean(dynamicUrlButton(template, publicUrl)?.matches) ||
  fields.some(field => String(field.value || '').includes(publicUrl));

const fillText = (text, fields, component) =>
  String(text || '').replace(VARIABLE_PATTERN, (match, key) => {
    const field = fields.find(
      item => item.component === component && item.key === key
    );
    return field?.value || match;
  });

export const renderTemplateText = (template, fields) =>
  [
    fillText(findComponent(template, 'HEADER')?.text, fields, 'header'),
    fillText(findComponent(template, 'BODY')?.text, fields, 'body'),
    findComponent(template, 'FOOTER')?.text || '',
  ]
    .filter(Boolean)
    .join('\n\n');

const paramsFor = (fields, component) =>
  Object.fromEntries(
    fields
      .filter(field => field.component === component)
      .map(field => [field.key, String(field.value || '').trim()])
  );

export const buildContractTemplateParams = (template, fields, publicUrl) => {
  const button = dynamicUrlButton(template, publicUrl);
  const header = paramsFor(fields, 'header');
  const processedParams = {
    body: paramsFor(fields, 'body'),
    ...(Object.keys(header).length ? { header } : {}),
    ...(button?.matches
      ? {
          buttons: [
            { type: 'url', parameter: button.suffix, index: button.index },
          ],
        }
      : {}),
  };

  return {
    name: template.name || template.friendly_name,
    namespace: template.namespace,
    language: template.language || 'pt_BR',
    processed_params: processedParams,
  };
};
